import { SpinBoundaryEndActionHandler, SpinBoundaryStartActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { AudioService } from "../audio/ports/AudioService";
import type { SpinBoundaryPacing } from "./SpinBoundaryPacing";

/**
 * The server-authoritative spin boundary: the audio cue for each edge, then the settle beat (`SpinBoundaryPacing`).
 * List it FIRST among the boundary listeners so the cue precedes every other reaction (the audio log
 * is part of the e2e contract).
 */
export function createSpinBoundaryPlugin(deps: { audioService: AudioService; spinBoundaryPacing: SpinBoundaryPacing }): ReplayPlugin {
  return {
    name: "spin-boundary",
    actionHandlers: [
      new SpinBoundaryStartActionHandler(async (input, context) => {
        deps.audioService.presentation.emit({ id: "spin.boundary.start" });
        await deps.spinBoundaryPacing.onSpinBoundaryStart(input, context);
      }),
      new SpinBoundaryEndActionHandler(async (input, context) => {
        deps.audioService.presentation.emit({ id: "spin.boundary.end" });
        await deps.spinBoundaryPacing.onSpinBoundaryEnd(input, context);
      }),
    ],
  };
}
